export default "__VITE_ASSET__2fe7a6c1__"